import { Row, Col } from "react-bootstrap"
import Table from '../../../../../../components/Table';

interface IThreeRiversSearchResults {
    billNumberLabel: string,
    nameLabel: string,
    dueDateLabel: string,
    amountDueLabel: string,
    paymentOptionsLabel: string,
    minimumPartialPaymentAmount: number,
    minimumPaymentText?: string,
    minimumPaymentErrorText?: string,
    allowOverpayment?: boolean,
    observesWeekends: boolean,
    durationOfPendingHours: number,
    overlayText: string,
    overlayBackground: string,
    overlayTextColor: string,
    overlayIconColor: string,
    noMatchFoundText: string,
    margin: string,
    padding: string,
    headerBackgroundColor: string,
    headerPadding: string,
}

export const BILL_NUMBER_LABEL = 'Bill Number';
export const NAME_LABEL = 'Name';
export const DUE_DATE_LABEL = 'Due Date';
export const AMOUNT_DUE_LABEL = 'Amount Due';
export const PAYMENT_OPTIONS_LABEL = 'Payment Options';
export const MINIMUM_PARTIAL_PAYMENT_AMOUNT = 0;
export const MINIMUM_PAYMENT_TEXT = 'Minimum partial payment: {amount}';
export const MINIMUM_PAYMENT_ERROR_TEXT = 'Partial payments must be at least {amount}';
export const ALLOW_OVERPAYMENT = true;
export const OBSERVES_WEEKENDS = false;
export const DURATION_OF_PENDING_HOURS = 24;
export const OVERLAY_TEXT = "I'm sorry. Your bill is not currently payable online, please call us at 1-800-253-0831 or visit our office for further assistance.";
export const OVERLAY_BACKGROUND = '#fef1b5';
export const OVERLAY_TEXT_COLOR = '#1e1e1e';
export const OVERLAY_ICON_COLOR = 'orange';
export const NO_MATCH_FOUND_TEXT = 'NO MATCH FOUND';
export const MARGIN = '0px';
export const PADDING = '0px';
export const HEADER_BACKGROUND_COLOR = 'rgb(250, 250, 250)';
export const HEADER_PADDING = '0';

const checkStyleForDefault = (style: string, defaultStyle: string) => {
    return style && style !== '' ? style : defaultStyle;
}

const ThreeRiversSearchResults = ({ billNumberLabel, nameLabel, dueDateLabel, amountDueLabel, paymentOptionsLabel,
    margin, padding, headerBackgroundColor, headerPadding }: IThreeRiversSearchResults) => {

    if (!billNumberLabel) { billNumberLabel = BILL_NUMBER_LABEL }
    if (!nameLabel) { nameLabel = NAME_LABEL }
    if (!dueDateLabel) { dueDateLabel = DUE_DATE_LABEL }
    if (!amountDueLabel) { amountDueLabel = AMOUNT_DUE_LABEL }
    if (!paymentOptionsLabel) { paymentOptionsLabel = PAYMENT_OPTIONS_LABEL }
    if (!margin) { margin = MARGIN }
    if (!padding) { padding = PADDING }
    if (!headerBackgroundColor) { headerBackgroundColor = HEADER_BACKGROUND_COLOR }
    if (!headerPadding) { headerPadding = HEADER_PADDING }

    const initialColumns = [{
        dataField: 'billNumber',
        text: billNumberLabel,
        headerStyle: {
            backgroundColor: checkStyleForDefault(headerBackgroundColor, HEADER_BACKGROUND_COLOR)
        },
    }, {
        dataField: 'name',
        text: nameLabel,
        headerStyle: {
            backgroundColor: checkStyleForDefault(headerBackgroundColor, HEADER_BACKGROUND_COLOR)
        },
    }, {
        dataField: 'dueDate',
        text: dueDateLabel,
        headerStyle: {
            backgroundColor: checkStyleForDefault(headerBackgroundColor, HEADER_BACKGROUND_COLOR)
        },
    }, {
        dataField: 'amountDue',
        text: amountDueLabel,
        headerStyle: {
            backgroundColor: checkStyleForDefault(headerBackgroundColor, HEADER_BACKGROUND_COLOR)
        },
    }, {
        dataField: 'status',
        text: 'Status',
        headerStyle: {
            backgroundColor: checkStyleForDefault(headerBackgroundColor, HEADER_BACKGROUND_COLOR)
        },
    }, {
        dataField: 'id',
        text: paymentOptionsLabel,
        headerStyle: {
            backgroundColor: checkStyleForDefault(headerBackgroundColor, HEADER_BACKGROUND_COLOR)
        },
    }];

    const renderTable = () => {
        return (
            <Table
                keyField="msbId"
                data={[]}
                columns={initialColumns}
            />);
    };

    return (
        <div style={{ margin: margin, padding: padding }}>
            <Row>
                <Col>
                    {renderTable()}
                </Col>
            </Row>
        </div>
    )
}

export default ThreeRiversSearchResults;
